import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomOwnerGroupField, validateOwnerGroup } from './CustomOwnerGroupField';

export const CustomOwnerGroupFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomOwnerGroupField',
    component: CustomOwnerGroupField,
    validation: validateOwnerGroup,
  }),
);
